export type LanguageType = 'en' | 'ru' | 'uk';

export interface LanguageConfig {
  code: LanguageType;
  name: string;
  nativeName: string;
}

export const languages: LanguageConfig[] = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский' },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська' },
];

export const defaultLanguage: LanguageType = 'en';
